<template>
  <div class="headingbasicdetailsrules">
    <p class="notification">Review your travel policy configuration and click "Save Policy" when you are completed. You will be able to edit this policy after it is saved.</p>

    <h3 class="title is-5">Basic Details</h3>

    <table class="table is-bordered is-fullwidth">
      <tr>
        <td style="width: 350px;">Travel policy name</td>
        <td>{{ policySummary.ruleClass ? policySummary.ruleClass : "N/A" }}</td>
      </tr>
      <tr>
        <td>Allow personal payment methods?</td>
        <td>{{ policySummary.allowPersonalPaymentMethods ? "Yes" : "No" }}</td>
      </tr>
      <tr>
        <td>Payment method(s)</td>
        <td v-if="policySummary.corporateGhostCard">
          {{
            policySummary.corporateGhostCard.brand +
            " Card ending in " +
            policySummary.corporateGhostCard.last4
          }}
        </td>
        <td v-else-if="policySummary.paymentAssociations && policySummary.paymentAssociations.length > 0">
            <ul>
              <li v-for="(card, index) in policySummary.paymentAssociations" :key="index">
                {{ card.brand }} card ending in {{ card.last4 }}
                <ul style="margin-top: 5px;list-style-type: circle">
                  <li>
                    Applicable Airlines:
                    <span v-if="card.appliedToAirVendorName && card.appliedToAirVendorName.length > 0">
                      {{ card.appliedToAirVendorName.join(', ') }}
                    </span>
                    <span v-else-if="card.appliedToAllAir">ALL</span>
                    <span v-else>None specified</span>
                  </li>
                  <li>
                    Applicable Hotels: 
                    <span v-if="card.appliedToHotelVendorName && card.appliedToHotelVendorName.length > 0">
                      {{ card.appliedToHotelVendorName.join(', ') }}
                    </span>
                    <span v-else-if="card.appliedToAllHotel">ALL</span>
                    <span v-else>None specified</span>
                  </li>
                </ul>
              </li>
            </ul>
        </td>
        <td v-else>
          N/A
        </td>
      </tr>
      
      <tr>
        <td>Email address to notify of all bookings</td>
        <td>{{ policySummary.ccEmail }}</td>
      </tr>
      <tr>
        <td>Do you want to allow basic economy/fares?</td>
        <td>{{ policySummary.showBasicEconomyFares }}</td>
      </tr>
      <tr>
        <td>
          Which cabin classes should be available in the flight search form?
        </td>
        <td>{{ policySummary.cabinOptions ? policySummary.cabinOptions.join(', ') : "" }}</td>
        <!-- <td>{{ policySummary.cabinOptions.join(', ') }}</td>-->
      </tr>
      <tr>
        <td>Allow travelers to select paid seats for corporate travel?</td>
        <td>{{ policySummary.selectPaidSeats }}</td>
      </tr>
    </table>

    <h3 class="title is-5">Standard Rules</h3>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <td style="width: 350px;">All Trips</td>
        <td>
          <span v-if="standardRules.all.length > 0">
            <ul>
              <li v-for="(item, index) in standardRules.all" :key="index">{{ item.message }}
                <a class="is-underlined" v-if="item.useCustomActions" @click="viewCustomActions(item)">Custom Actions</a>
              </li>
            </ul>
          </span>
          <span v-else class="has-text-grey">No rules configured</span>
        </td>
      </tr>
      <tr>
        <td>Air Rules</td>
        <td>
          <span v-if="standardRules.air.length > 0">
            <ul>
              <li v-for="(item, index) in standardRules.air" :key="index">{{ item.message }}
                <a class="is-underlined" v-if="item.useCustomActions" @click="viewCustomActions(item)">Custom Actions</a>
              </li>
            
            </ul>
          </span>
          <span v-else class="has-text-grey">No rules configured</span>
        </td>
      </tr>
      <tr>
        <td>Car Rules</td>
        <td>
          <span v-if="standardRules.car.length > 0">
            <ul>
              <li v-for="(item, index) in standardRules.car" :key="index">{{ item.message }}
                <a class="is-underlined" v-if="item.useCustomActions" @click="viewCustomActions(item)">Custom Actions</a>
              </li>
            </ul>
          </span>
          <span v-else class="has-text-grey">No rules configured</span>
        </td>
      </tr>
      <tr>
        <td>Hotel</td>
        <td>
          <span v-if="standardRules.hotel.length > 0">
            <ul>
              <li v-for="(item, index) in standardRules.hotel" :key="index">{{ item.message }}
                <a class="is-underlined" v-if="item.useCustomActions" @click="viewCustomActions(item)">Custom Actions</a>
              </li>
            </ul>
          </span>
          <span v-else class="has-text-grey">No rules configured</span>
        </td>
      </tr>
    </table>

    <h3 class="title is-5">Custom Rules</h3>
    <table class="table is-bordered is-fullwidth">
      <tr>
        <td style="width: 350px;">Air Rules</td>
        <td>
          <span v-if="customRules.air.length > 0">
            <ul>
              <!-- <li v-for="(item, index) in customRules.air" :key="index" v-html="$helpers.buildTravelPolicyRuleMessage(item)"></li> -->
              <li v-for="(item, index) in customRules.air" :key="index">
                <span v-html="$helpers.buildTravelPolicyRuleMessage(item)"></span>
                <a class="is-underlined pl-2" v-if="item.actionType == 'Custom'" @click="viewCustomActions(item)">Custom Actions</a>
              </li>
            </ul>
          </span>
          <span v-else class="has-text-grey">No rules configured</span>
        </td>
      </tr>
      <tr>
        <td>Car Rules</td>
        <td>
          <span v-if="customRules.car.length > 0">
            <ul>
              <li v-for="(item, index) in customRules.car" :key="index">
                <span v-html="$helpers.buildTravelPolicyRuleMessage(item)"></span>
                <a class="is-underlined pl-2" v-if="item.actionType == 'Custom'" @click="viewCustomActions(item)">Custom Actions</a>
              </li>
            </ul>
          </span>
          <span v-else class="has-text-grey">No rules configured</span>
        </td>
      </tr>
      <tr>
        <td>Hotel</td>
        <td>
          <span v-if="customRules.hotel.length > 0">
            <ul>
              <li v-for="(item, index) in customRules.hotel" :key="index">
                <span v-html="$helpers.buildTravelPolicyRuleMessage(item)"></span>
                <a class="is-underlined pl-2" v-if="item.actionType == 'Custom'" @click="viewCustomActions(item)">Custom Actions</a>
              </li>
            </ul>
          </span>
          <span v-else class="has-text-grey">No rules configured</span>
        </td>
      </tr>
    </table>

    <!-- TODO: Finish building rules summary -->

    <h3 class="title is-5">Actions</h3>

    <!-- TODO: Finish building actions summary -->

    <table class="table is-bordered is-fullwidth">
      <tr>
        <td style="width: 350px;">
          <div class="has-text-weight-bold">Result visibility</div>
          How do you want to display a result that violates a rule?
        </td>
        <td>
          {{
            $helpers.getTravelPolicyViolationVisibilityLabel(
              policySummary.visibility
            )
          }}
        </td>
      </tr>
      <tr>
        <td>
          <div class="has-text-weight-bold">Approval level</div>
          What level of approval do you want when a traveler books an option
          that violates a rule?
        </td>
        <td>
          {{
            $helpers.getTravelPolicyViolationAction(policySummary.approvalLevel)
          }}
        </td>
      </tr>
      <tr v-if="policySummary.notifications">
        <td>
          <div class="has-text-weight-bold">Notifications</div>
          Where should notifications be sent when a traveller books an option
          that violates a rule?
        </td>
        <td>
          <ul>
            <li v-if="policySummary.notifications.managerViaEmail">
              Notify manager via email
            </li>
            <li v-if="policySummary.notifications.managerViaSms">
              Notify manager via SMS
            </li>
            <li v-if="policySummary.notifications.email.length > 0">
              Send email to {{ policySummary.notifications.email.join() }}
            </li>
            <li v-if="policySummary.notifications.sms.length > 0">
              Send SMS to {{ policySummary.notifications.sms.join() }}
            </li>
          </ul>
        </td>
      </tr>
    </table>

  </div>
  
</template>
<script>
import CustomActionsSummaryModal from "./CustomActionsSummaryModal.vue";
export default {
  name: "Summary",
  components: {},
  props: {
    travelPolicy: Object,
  },
  data() {
    return {
      policySummary: {},
    };
  },
  computed: {
    standardRules() {
      const rules = this.policySummary.rules || [];
      return {
        all: rules.filter(rule => rule.type === 'all' && rule.isActive),
        air: rules.filter(rule => rule.type === 'air' && rule.isActive),
        car: rules.filter(rule => rule.type === 'car' && rule.isActive),
        hotel: rules.filter(rule => rule.type === 'hotel' && rule.isActive),
      };
    },
    customRules() {
      const rules = this.policySummary.customRules || [];
      return {
        air: rules.filter(rule => rule.category === 'air' && rule.status !== 'inactive'),
        car: rules.filter(rule => rule.category === 'car' && rule.status !== 'inactive'),
        hotel: rules.filter(rule => rule.category === 'hotel' && rule.status !== 'inactive'),
      };
    },
  },
  methods: {
    getStandardRules(type) {
      var rules = this.policySummary ? this.policySummary.rules : [];
     
      return rules
        ? rules.filter((rule) => rule.type == type && rule.isActive)
        : [];
    },
    getCustomRules(type) {
      var rules = this.policySummary ? this.policySummary.customRules : [];
      return rules
        ? rules.filter(
            (rule) => rule.category == type && rule.status != "inactive"
          )
        : [];
    },
    viewCustomActions(rule){
      this.$buefy.modal.open({
          parent: this,
          component: CustomActionsSummaryModal,
          hasModalCard: true,
          customClass: "",
          trapFocus: true,
          props: {
            rule: rule
          },
      });
    },
    arrayToCommaString(array) {
      if (Array.isArray(array) && array.length) {
        return array.join(',');
      }
      return '';
    }
  },
  mounted() {},
  watch: {
    travelPolicy: {
      handler(newVal, prevVal) {
        this.policySummary = newVal;
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
